import styled from 'styled-components';
import { NEUTRAL_200 } from 'visitor-ui-component-library/constants/WidgetColors';
const ConsentPromptWrapper = styled.div.withConfig({
  displayName: "ConsentPromptWrapper"
})(["padding:", ";margin-bottom:", ";background:", ";"], ({
  $isSpotlight
}) => $isSpotlight ? '24px' : '12px 16px', ({
  $isPortal53
}) => $isPortal53 ? '8px' : '0', ({
  $isPortal53
}) => $isPortal53 ? NEUTRAL_200 : 'transparent');
export default ConsentPromptWrapper;